var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavoriteActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1718_1467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3787 7.11065C23.6715 4.40633 19.3323 4.30071 16.5001 6.79419C13.6683 4.30084 9.32906 4.40633 6.6216 7.11065C5.2488 8.48199 4.5 10.2945 4.5 12.2221C4.5 14.1498 5.2488 15.9622 6.6216 17.3239L16.164 26.8562C16.2504 26.9425 16.3752 27 16.5 27C16.6248 27 16.7496 26.9521 16.836 26.8562L26.3784 17.3239C27.7416 15.9622 28.5 14.1498 28.5 12.2221C28.5 10.2945 27.7515 8.48212 26.3787 7.11065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55093 7.0399L6.55093 7.0399C5.15935 8.43 4.4 10.2679 4.4 12.2221C4.4 14.1762 5.15925 16.0141 6.55097 17.3947C6.55104 17.3948 6.55111 17.3948 6.55118 17.3949L16.0933 26.9269C16.1964 27.0299 16.3459 27.1 16.5 27.1C16.6486 27.1 16.8009 27.0433 16.9085 26.9252L26.4491 17.3947C27.8309 16.0143 28.6 14.1766 28.6 12.2221C28.6 10.2679 27.8409 8.43013 26.4493 7.03991L26.3787 7.11065L26.4493 7.0399C23.7255 4.31902 19.3726 4.19281 16.5001 6.66165C13.6279 4.19294 9.27496 4.31902 6.55093 7.0399Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1718_1467",
    x: 0.300049,
    y: 0.800049,
    width: 32.3999,
    height: 30.3999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1718_1467"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1718_1467",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteActive);
export default __webpack_public_path__ + "static/media/favorite_active.b3ce593ab6620c57ce2deb202709126f.svg";
export { ForwardRef as ReactComponent };